import IActionType from '../interfaces/IActionType';
import * as actionTypes from './actionTypes';

export const ehFormularioSomenteLeitura = (ehFormularioSomenteLeitura: boolean): IActionType<boolean> => ({
  type: actionTypes.ALTERAR_EH_FORMULARIO_SOMENTE_LEITURA,
  state: ehFormularioSomenteLeitura
});